/** Shared with page preparation, the viewer and response-cache policy. */
export const PULSE_PATH = "/api/workspace/pulse";
export const HISTORY_PATH = "/api/workspace/product-history";
export const HISTORY_DETAIL_PATH = "/api/workspace/product-history/detail";
export const PULSE_CURRENT_DEMAND_ENDPOINT = "/api/workspace/pulse-current-demand";
export const PULSE_RESPONSE_PATHS = [PULSE_PATH, HISTORY_PATH, HISTORY_DETAIL_PATH, PULSE_CURRENT_DEMAND_ENDPOINT] as const;
